import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { LoginComponent } from 'src/app/shared/components/login/login/login.component';
import { AccueilComponent } from 'src/app/user/components/accueil/accueil.component';
import { ProductCatalogComponent } from 'src-ironside/product-catalog/product-catalog.component';
import { NewProductComponent } from 'src-ironside/new-product/new-product.component';
import { NewProductDetailComponent } from 'src-ironside/new-product/new-productDetail/new-productDetail.component';
import { FournisseursIronsideComponent } from 'src-ironside/fournisseurs-ironside/fournisseurs-ironside.component';
import { ListPartnersComponent } from 'src-ironside/list-partners/list-partners.component';
import { PartnersDetailComponent } from 'src-ironside/list-partners/partners-detail/partners-detail.component';
import { MyPartnersComponent } from 'src-ironside/list-partners/my-partners/my-partners.component';
import { MyFavouritesComponent } from 'src-ironside/my-favourites/my-favourites.component';
import { YellowFocusComponent } from 'src-ironside/yellow-focus/yellow-focus.component';
import { MyAccountIronsideComponent } from 'src-ironside/my-account/my-account-ironside.component';
import { AuthGuardService } from 'src/app/shared/core/interceptors/auth-guard.service';
import { DashboardComponent } from 'src/app/admin/core/components/dashboard/dashboard.component';
import { fromPATH } from 'src-ironside/services/screen.mediator';
import { ForgotPasswordComponent } from 'src/app/shared/components/forgot-password/forgot-password.component';
import { RetrievePasswordComponent } from 'src/app/shared/components/retrieve-password/retrieve-password.component';
import { ChangerMotDePasseComponent } from 'src/app/shared/components/changer-mot-de-passe/changer-mot-de-passe.component';
import { LogoutComponent } from 'src/app/shared/components/logout/logout.component';
import { ResourceFileRedirectComponent } from 'src/app/shared/components/resource-file-redirect/resource-file-redirect.component';
// import { ProductComparatorComponent } from 'src-ironside/product-comparator/product-comparator.component';
import { ContactPageComponent } from 'src-ironside/contact-page/contact-page.component';
import { ChiffrePageComponent } from 'src-ironside/dowload-page/chiffre-page.component';
import { ProductComparatorIronsideComponent } from 'src-ironside/product-comparator-ironside/product-comparator-ironside.component';
import { FournisseurDetailComponent } from 'src-ironside/fournisseurs-ironside/fournisseur-detail/fournisseur-detail.component';
import { ExternalDownloadComponent } from 'src-ironside/dowload-page/external-download/external-download.component';
import { LogisticImportComponent } from 'src/app/shared/components/logistic-import/logistic-import.component';
import { SimpleAuthGuardService } from 'src/app/shared/core/interceptors/simple-auth-guard.service copy';

export const PATHS = {
    login: 'login',
    logout: 'logout',
    admin: 'admin',
    retrievepassword: 'retrievepassword',
    customID: ':id',
    import: 'import',
    //
    home: 'home',
    home_en: 'home',
    home_fr: 'accueil',
    home_es: 'inicio',
    home_de: 'startseite',
    external_download: 'ironside-resources',

    //
    research: 'research',

    //
    catalogues: 'catalogue',
    catalogues_en: 'catalog',
    catalogues_fr: 'catalogue',
    catalogues_es: 'catalogo',
    catalogues_de: 'katalog',

    //
    newProduct: 'nouveau-produit',
    nouveauProduit_en: 'new-product',
    nouveauProduit_fr: 'nouveau-produit',
    nouveauProduit_es: 'nouveau-produit',
    nouveauProduit_de: 'nouveau-produit',

    //
    product: 'produit',
    product_en: 'product',
    product_fr: 'produit',
    product_es: 'producto',
    product_de: 'produkt',

    //
    suppliers: 'fournisseurs',
    suppliers_en: 'suppliers',
    suppliers_fr: 'fournisseurs',
    suppliers_es: 'proveedores',
    suppliers_de: 'lieferanten',

    //
    partners: 'partenaires',
    partners_en: 'partners',
    partners_fr: 'partenaires',
    partners_es: 'socios',
    partners_de: 'partner',

    //
    monPartenaire: 'mon-partenaire',
    monPartenaire_en: 'my-partner',
    monPartenaire_fr: 'mon-partenaire',
    monPartenaire_es: 'mi-pareja',
    monPartenaire_de: 'meine-partnerin',

    //
    mesFavoris: 'my-favorites',

    //
    yellowFocus: 'yellow-focus',

    //
    contactPage: 'contact',

    //
    chiffre: 'downloads',

    //
    myAccount: 'my-account',

    //
    machines: 'machines',
    machines_en: 'machines',
    machines_fr: 'machines',
    machines_es: 'maquinas',
    machines_de: 'maschinen',
    //
    consumables: 'consommables',
    consumables_en: 'consumables',
    consumables_fr: 'consommables',
    consumables_es: 'consumibles',
    consumables_de: 'verbrauchsmaterialen',
    //
    technologies: 'technologies',
    technologies_en: 'technologies',
    technologies_fr: 'technologies',
    technologies_es: 'tecnologias',
    technologies_de: 'technologien',
    //
    company: 'societe',
    company_en: 'company',
    company_fr: 'societe',
    company_es: 'empresa',
    company_de: 'geschaft',
    //
    news: 'actualites',
    news_en: 'news',
    news_fr: 'actualites',
    news_es: 'noticias',
    news_de: 'neuigkeiten',
    //
    contact: 'contact',
    contact_en: 'contact',
    contact_fr: 'contact',
    contact_es: 'contacto',
    contact_de: 'kontakt',
    // product comparator
    product_comparator: 'product-comparator',
    product_comparator_en: 'product-comparator',
    product_comparator_fr: 'produit-comparateur',
    product_comparator_es: 'productos-comparador',
    product_comparator_de: 'produktvergleich',
    //
    account: 'mon-compte',
    devis: 'devis',
    favorite: 'favoris',
    forgot: 'forgot-password',
    retrieve: 'retrievepassword/reset',
    //
    modifyPassword: 'changer-mot-de-passe',
    fournisseur: 'fournisseur',
    monEspace: 'espace',
    moncatalogues: 'catalogues',
    monEurochef: 'catalogues-eurochef',
    bibliotheque: 'biblo',
    gestion: 'gestion',
    gestion_article: 'articles',
    gestion_fournisseurs: 'suppliers',
    gestion_marques: 'brands',
    gestion_associe: 'associe',
    gestion_clients: 'clients',
    categorie: 'categorie',
    associates: 'associes',
    roles: 'roles',
    projectOverview: 'project-overview',
    projectDetail: 'project-detail',
    resourceFilesRedirect: 'resource-files-redirect',
};

export const OGPATHS = {
    home: 'home',
    catalogue: 'catalogue',
    product: 'product',
    machines: 'fournisseurs',
    consumables: 'partners',
    tools: 'chiffre',
    technologies: 'showroom',
    company: 'yellow-focus',
    contact: 'contact',
};
const routes: Routes = [
    {
        path: `${PATHS.admin}/${PATHS.resourceFilesRedirect}/${PATHS.customID}`,
        component: ResourceFileRedirectComponent,
    },

    // { path: '', redirectTo: `${PATHS.home_en}` },
    // { path: '*', redirectTo: `${PATHS.home_en}` },
    // { path: '/', redirectTo: `${PATHS.home_en}` },
    { path: PATHS.login, component: LoginComponent },

    { path: PATHS.logout, component: LogoutComponent },
    {
        path: `${PATHS.admin}/${PATHS.customID}`,
        component: DashboardComponent,
        canActivate: [AuthGuardService],
    },
    { path: PATHS.forgot, component: ForgotPasswordComponent },
    { path: PATHS.retrieve, component: RetrievePasswordComponent },
    { path: PATHS.modifyPassword, component: ChangerMotDePasseComponent },

    { path: `${PATHS.home_en}`, component: AccueilComponent, canActivate: [AuthGuardService] },

    { path: `${PATHS.research}`, component: NewProductComponent, data: { from: fromPATH.accueil } },

    {
        path: `${PATHS.nouveauProduit_en}`,
        component: NewProductComponent,
        data: { from: fromPATH.header },
    },

    { path: `${PATHS.catalogues_en}`, component: ProductCatalogComponent },

    { path: `${PATHS.nouveauProduit_en}`, component: NewProductComponent },

    {
        path: `${PATHS.product_en}/detail/:id`,
        component: NewProductDetailComponent,
    },

    { path: `${PATHS.suppliers_en}`, component: FournisseursIronsideComponent },
    {
        path: `${PATHS.suppliers_en}/detail/:supplierId`,
        component: NewProductComponent,
        data: { from: fromPATH.supplier },
    },
    {
        path: `${PATHS.suppliers_en}/detail-supplier/:supplierId`,
        component: FournisseurDetailComponent,
        data: { from: fromPATH.supplier },
    },

    {
        path: `${PATHS.gestion_marques}/detail/:marqueId`,
        component: NewProductComponent,
        data: { from: fromPATH.marque },
    },

    { path: `${PATHS.partners_en}`, component: ListPartnersComponent },

    { path: `${PATHS.partners_en}/detail/:code`, component: PartnersDetailComponent },

    {
        path: `${PATHS.partners_en}/${PATHS.monPartenaire_en}`,
        component: MyPartnersComponent,
    },
    { path: `${PATHS.external_download}`, component: ExternalDownloadComponent },

    { path: `${PATHS.mesFavoris}`, component: MyFavouritesComponent },

    { path: `${PATHS.yellowFocus}`, component: YellowFocusComponent },

    { path: `${PATHS.contactPage}`, component: ContactPageComponent },

    { path: `${PATHS.chiffre}`, component: ChiffrePageComponent },

    { path: `${PATHS.myAccount}`, component: MyAccountIronsideComponent },

    {
        path: `${PATHS.admin}/${PATHS.customID}`,
        component: DashboardComponent,
        //   canActivate: [AuthGuardService],
    },

    {
        path: `${PATHS.product_comparator}`,
        component: ProductComparatorIronsideComponent,
        canActivate: [AuthGuardService],
    },

    {
        path: `${PATHS.import}`,
        component: LogisticImportComponent,
        canActivate: [SimpleAuthGuardService],
    },

    { path: '**', redirectTo: `${PATHS.login}` },
    { path: '', redirectTo: `${PATHS.login}` },
    { path: '*', redirectTo: `${PATHS.login}` },
    { path: '/', redirectTo: `${PATHS.login}` },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
